// generated by the plop

import { PROGRESS_STATUSES } from 'symbols';

export interface MastersStateModel {
  currentMasters: MasterModel[];
  allMasters: MasterModel[];
  loadMastersStatus: PROGRESS_STATUSES;
}

export const MASTERS_STATE_DEFAULT: MastersStateModel = {
  currentMasters: [],
  allMasters: [],
  loadMastersStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};


export interface MasterModel {
  id: string;
  firstName: string;
  lastName: string;
  tel: string;
  code: string;
  avatar?: string;
  lastLocationUpdate: string;
  latitude: number;
  longitude: number;
}
